import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => {
  const { primary, secondary } = theme.palette;

  return {
    tabs: {
      justifyContent: "space-between",
      "& .MuiTabs-indicator": {
        backgroundColor: secondary.dark,
        bottom: 5
      }
    },
    tab: {
      minWidth: 50,
      maxWidth: "none",
      minHeight: 45,
      height: 45,
      flexBasis: "33%",
      flexGrow: 1,
      color: theme.palette.text.secondary,
      textTransform: "capitalize",
      fontSize: 16,
      "&.Mui-selected": {
        color: primary.main
      }
    }
  };
});
